import {Component, ContentChild, input, OnInit, TemplateRef} from '@angular/core';
import {NgTemplateOutlet} from "@angular/common";
import {
    AppTableBodyTemplateDirective,
    AppTableFooterTemplateDirective,
    AppTableHeaderTemplateDirective
} from "@shared/components/tables/app-table/directives/app-table.directives";
import {AutoDataLabelDirective} from "@shared/directives/auto-data-label.directive";

@Component({
    selector: 'app-table',
    templateUrl: './app-table.component.html',
    styleUrls: ['./app-table.component.scss'],
    imports: [NgTemplateOutlet, AutoDataLabelDirective],
    standalone: true
})
export class AppTableComponent implements OnInit {
    @ContentChild(AppTableHeaderTemplateDirective, {read: TemplateRef}) headerTemplate: TemplateRef<any> | undefined;
    @ContentChild(AppTableBodyTemplateDirective, {read: TemplateRef}) bodyTemplate: TemplateRef<any> | undefined;
    @ContentChild(AppTableFooterTemplateDirective, {read: TemplateRef}) footerTemplate: TemplateRef<any> | undefined;

    tableData = input<any[]>([]);

    constructor() {
    }

    ngOnInit(): void {
    }
}
